<template>
  <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>A5BECE70-B920-4221-AD10-B8EA434E3A3D</title>
    <defs>
      <filter id="filter-1">
        <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.188235 0 0 0 0 0.188235 0 0 0 0 0.188235 0 0 0 1.000000 0"></feColorMatrix>
      </filter>
    </defs>
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Variables/Icon/Apps" transform="translate(-1168.000000, -16.000000)" filter="url(#filter-1)">
        <g transform="translate(1168.000000, 16.000000)" id="Icon" fill="#000000" fill-rule="nonzero">
          <path d="M34.5,32.64 L34.5,31.41 L31.98,28.89 L31.98,22.68 C31.98,20.74 31.49,19.06 30.51,17.64 C29.51,16.16 28.13,15.2 26.37,14.76 L26.37,14.76 L26.37,13.89 C26.37,13.37 26.185,12.925 25.815,12.555 C25.445,12.185 25,12 24.48,12 C23.96,12 23.52,12.185 23.16,12.555 C22.8,12.925 22.62,13.37 22.62,13.89 L22.62,13.89 L22.62,14.76 C20.84,15.2 19.45,16.15 18.45,17.61 C17.47,19.03 16.98,20.72 16.98,22.68 L16.98,22.68 L16.98,28.89 L14.46,31.41 L14.46,32.64 L34.5,32.64 Z M36.96,22.02 C36.88,20.06 36.37,18.22 35.43,16.5 C34.53,14.82 33.32,13.4 31.8,12.24 L31.8,12.24 L30.06,14.01 C31.34,14.93 32.36,16.07 33.12,17.43 C33.92,18.85 34.36,20.38 34.44,22.02 L34.44,22.02 L36.96,22.02 Z M14.52,22.02 C14.6,20.38 15.04,18.85 15.84,17.43 C16.62,16.07 17.66,14.93 18.96,14.01 L18.96,14.01 L17.16,12.24 C15.64,13.4 14.43,14.82 13.53,16.5 C12.59,18.22 12.08,20.06 12,22.02 L12,22.02 L14.52,22.02 Z M24.48,36.39 C25.18,36.39 25.765,36.16 26.235,35.7 C26.705,35.24 26.94,34.65 26.94,33.93 L26.94,33.93 L21.96,33.93 C21.96,34.61 22.205,35.19 22.695,35.67 C23.185,36.15 23.78,36.39 24.48,36.39 Z" id=""></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BellIcon',
};
</script>

<style scoped>

</style>
